import { useState } from 'react';
import { MentionCard } from './MentionCard/MentionCard';
import { IGroupedMentionWithMentioner } from 'types/dashboard.types';
import { NudosButton } from 'components/NudosComponents';

import './MentionsList.scss';

interface IMentionsListProps {
  mentions: IGroupedMentionWithMentioner[];
  title: string;
  titleColor: string;
  redirectUrl: string;
  reloadData: () => Promise<void>;
}

export const MentionsList = ({ mentions, title, titleColor, redirectUrl, reloadData }: IMentionsListProps) => {
  const [showAll, setShowAll] = useState(false);

  const MIN_TO_SHOW = 3;
  const showToggle = mentions.length > MIN_TO_SHOW;
  const displayed = showToggle && !showAll ? mentions.slice(0, MIN_TO_SHOW) : mentions;
  const toggleText = `(${mentions.length - MIN_TO_SHOW}) Ver ${showAll ? 'menos' : 'más'}`;

  const handleToggle = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="mentionsListContainer">
      <h4 className="mentionsListTitle" style={{ color: titleColor }}>
        {title}
      </h4>

      <div className="mentionsList">
        {displayed.map(mention => (
          <MentionCard
            key={mention.id}
            mention={mention}
            redirectUrl={redirectUrl}
            reloadData={reloadData}
            showLoader={false}
          />
        ))}

        {showToggle && (
          <div className="showMoreButton">
            <NudosButton
              buttonText={toggleText}
              handleClick={handleToggle}
              customClassName="p-8"
              customWidth="max-content"
              customHeight="max-content"
            />
          </div>
        )}
      </div>
    </div>
  );
};
